<template lang="pug">
div
    button.button.is-large.is-fullwidth.is-danger(@click='clear_pin_prompt') {{clear_pin_text}}
    #clear_prompt.modal
      .modal-background
      .modal-card
        .modal-card-head
          .title(style="color:black") {{clear_pin_text}}?
        .modal-card-body
          section.message.is-medium
            .message-body
              p(style="font-weight:bold") {{clear_all_data}}
              p {{reentered}} 
          button(style="margin:1rem").button.is-large.is-info(@click="close_clear_pin_prompt") {{nevermind}}
          button(style="margin:1rem").button.is-large.is-danger(@click="clear_pin") {{clear_pin_text}}
    #pin_timer_prompt.modal
      .modal-background
      StopTimers(@prompt-closed="close_prompt")

</template>

<script>
import { mapState } from "vuex";
import StopTimers from "@/components/StopTimers";
export default {
  name: "ClearPin",
  props: {},
  date: function() {
    return {};
  },
  components: {
    StopTimers
  },
  computed: {
    ...mapState(["language"]),
    clear_pin_text: function() {
      if (this.language == "en") return "Clear Pin";
      else return "Cerrar sesión";
    },
    nevermind() {
      if (this.language == "en") return "Nevermind";
      else return "Cancelar";
    },
    clear_all_data() {
      if (this.language == "en") return "Clear all data?";
      else return "¿borrar todos los datos";
    },
    reentered() {
      if (this.language == "en")
        return "PIN must be re-entered to use app again.";
      else return "Se debe ingresar la contraseña para usar nuevamente";
    }
  },
  methods: {
    clear_pin_prompt() {
      // check for active timers.
      if (this.$store.getters.active_timers) {
        document.getElementById("pin_timer_prompt").classList.add("is-active");
      } else {
        document.getElementById("clear_prompt").classList.add("is-active");
      }
    },
    close_clear_pin_prompt() {
      document.getElementById("clear_prompt").classList.remove("is-active");
    },
    close_prompt() {
      document.getElementById("pin_timer_prompt").classList.remove("is-active");
    },
    clear_pin() {
      this.$store.commit("login", null);
      localStorage.setItem("kiosk-pin", "123");
      localStorage.clear();
      this.close_clear_pin_prompt();
    }
  }
};
</script>

<style scoped lang="less">
.modal-card {
  max-width: 500px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>
